import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-manual-diagnosis',
  templateUrl: './manual-diagnosis.component.html',
  styleUrls: ['./manual-diagnosis.component.scss']
})
export class ManualDiagnosisComponent implements OnInit {
  public filter: boolean = false;
  public vinNumber = '';
  public tokenObj: any;
  public userId: any;
  public infotab:boolean= false;
  public hintstab:boolean= false;
  public submittab:boolean= false;
  public sessionId:any;
  vin:any
  dealerCode:any
  countrythree:any
  modelYear:any
  username:any
  vindetails:any
  vehicle:any
  language:any
  country:any
  constructor(private service: ApifirstService, private router: Router) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      let c: any
      c = data
      this.language = c.language
      this.country = c.country
      this.dealerCode = c.dealerCode
      this.countrythree = c.countryThree
      this.vin = c.vin
      this.username = c.username
    })
    this.vinNumber=this.tokenObj.vin
    this.sessionId=localStorage.getItem("sessionID")
  }
  getIdentifyFailure() {
    this.vinNumber=this.tokenObj.vin
    this.service.userId.subscribe((data) => {
      this.userId = data
     
    })
    const identifyObj = {
      "vin": this.vinNumber,
      "filtered": "true",
      "diagnostic": "true",
      "userId": this.userId,
      "userType": this.tokenObj.userType,
      "languageCode": this.tokenObj.language,
      "countryCode": this.tokenObj.countryThree,
      "sessionId":this.sessionId
    }
    this.service.getIdentifydetails(identifyObj).subscribe((data) => {
      this.service.identifyDetails.next(data)
      this.router.navigateByUrl('/identifyFailure')
    })
  }
  hotlineHints(){
    this.infotab = false;
    this.service.infotab.next(this.infotab)
    this.hintstab = true;
    this.service.hintstab.next(this.hintstab)
    this.submittab = false;
    this.service.submittab.next(this.submittab)

  }
  hotlineInfo(){
    this.infotab = true;
    this.service.infotab.next(this.infotab)
    this.hintstab = false;
    this.service.hintstab.next(this.hintstab)
    this.submittab = false;
    this.service.submittab.next(this.submittab)
  }
  // hotlineSubmit() {
  //   const request = {
  //     "vin": this.vin,
  //     "paCode": this.dealerCode,
  //     "country": this.countrythree,
  //     "language": this.language
  //   }
  //   this.service.getVindetails(request).subscribe((data) => {
  //     this.vindetails = data
  //     console.log(this.vindetails)
  //     this.modelYear = this.vindetails.modelYear
  //     console.log(this.modelYear, "modelYear")
  //     this.vehicle = this.vindetails.vehicleLineDescription
  //     //const newWindow = window.open('https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?Year='+this.modelYear+'&BD=09-10-2015&LANG=EN-US&Transmission=6+Speed+Auto+Trans+6F35&Model=Mondeo+2014+-&Contactid=&vin=WF0EXXWPCEFU07509&USERID=g-gbr&WDS=15-10-2015&Engine=2.0L+EcoBoost+%28240PS%29&Body=5+Door+Saloon&Symptom_codes=&GEO=GBR&PACODE=GBR50089AA&dswid=-9183','_blank', 'width=700,height=700');
  //     const newWindow = window.open('https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?LANG=' + this.language + '-US&Contactid=&vin=' + this.vin + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');
  //   }
  //   )
  //   console.log(this.modelYear, "modelYear")



  //   // this.router.navigateByUrl(["https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?Year=2016&BD=09-10-2015&LANG=EN-US&Transmission=6+Speed+Auto+Trans+6F35&Model=Mondeo+2014+-&Contactid=&vin=WF0EXXWPCEFU07509&USERID=g-gbr&WDS=15-10-2015&Engine=2.0L+EcoBoost+%28240PS%29&Body=5+Door+Saloon&Symptom_codes=&GEO=GBR&PACODE=GBR50089AA&dswid=-9183"])

  // }
}
